var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPositiveCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0949 17.9167C29.4133 17.9167 17.5115 29.8184 17.5115 44.5C17.5115 59.1816 29.4133 71.0833 44.0949 71.0833C58.7764 71.0833 70.6782 59.1816 70.6782 44.5C70.6782 29.8184 58.7764 17.9167 44.0949 17.9167ZM11.5115 44.5C11.5115 26.5047 26.0996 11.9167 44.0949 11.9167C62.0902 11.9167 76.6782 26.5047 76.6782 44.5C76.6782 62.4953 62.0902 77.0833 44.0949 77.0833C26.0996 77.0833 11.5115 62.4953 11.5115 44.5ZM59.5287 33.5037C60.7003 34.6752 60.7003 36.5747 59.5287 37.7463L41.7787 55.4963C40.6071 56.6679 38.7076 56.6679 37.5361 55.4963L28.6611 46.6213C27.4895 45.4497 27.4895 43.5502 28.6611 42.3787C29.8326 41.2071 31.7321 41.2071 32.9037 42.3787L39.6574 49.1323L55.2861 33.5037C56.4576 32.3321 58.3571 32.3321 59.5287 33.5037Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveCheck);
export default __webpack_public_path__ + "static/media/positiveCheck.0f66308e.svg";
export { ForwardRef as ReactComponent };